import React from "react";
import {Button, Tooltip} from "@material-ui/core";
import Stack from "@mui/material/Stack";
import PersonAdd from "@material-ui/icons/PersonAdd";
import {CleverAdhocRosterDialog} from "./rostering/CleverAdhocRosterDialog";
import {useEffect, useState} from "react";
import CleverRosterApi from "../../../../services/CleverRosterApi";
import {
    navigateToTestTakerSearch,
} from "../../../reports/common/components/TestTakerSearch/components/TestTakerSearchLink"
import {useHistory} from "react-router"

export const CustomSectionsRosterStudent: React.FC = (props) => {
    const [rosterOpen, setRosterOpen] = useState(false)
    const [canView, setCanView] = useState(false)
    const history = useHistory()

    useEffect(() => {
        CleverRosterApi.customSectionsAllowed()
            .then((response) => {
                if (response === true) {setCanView(true)} else {setCanView(false)}
            })
    }, [])

    const handleRosterStudents = () => {
        setRosterOpen(true)
    }
    const handleRosterClose = async () => {
        setRosterOpen(false)
    }
    return (
            <>
            {canView && (
                <Stack sx={{gap: 1}}>
                    <Tooltip title={"Roster Student to Custom Sections"}>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth={true}
                            startIcon={<PersonAdd/>}
                            onClick={handleRosterStudents}
                        >
                            Roster Custom Sections
                        </Button>
                    </Tooltip>
                    <Tooltip title={"Search for Individual Test Takers"}>
                        <Button fullWidth={true}
                                variant={"contained"}
                                color={"primary"}
                                onClick={() => navigateToTestTakerSearch(history)}>
                            Test Taker Search</Button>
                    </Tooltip>
                </Stack>
            )}
            <CleverAdhocRosterDialog
                open={rosterOpen}
                handleRosterClose={handleRosterClose}
            />
        </>
    )
}